import { NgStyle } from '@angular/common';
import { AfterViewInit, ChangeDetectionStrategy, Component, Inject, ViewChild } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogTitle } from '@angular/material/dialog';
import { MatDivider } from '@angular/material/list';
import { Commentable, CommentListComponent } from '@ng-cloud/badger-core';
import { StyleDirective } from '@ngbracket/ngx-layout/extended';
import { FlexDirective, FlexFillDirective, LayoutDirective, LayoutGapDirective } from '@ngbracket/ngx-layout/flex';
import { TranslatePipe } from '@ngx-translate/core';
import { CommentableListComponent } from '../commentable-list/commentable-list.component';

@Component({
  selector: 'bt-comments',
  templateUrl: './comments.component.html',
  styleUrls: ['./comments.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    CommentableListComponent,
    CommentListComponent,
    FlexDirective,
    FlexFillDirective,
    LayoutDirective,
    LayoutGapDirective,
    MatButton,
    MatDialogActions,
    MatDialogClose,
    MatDialogContent,
    MatDialogTitle,
    MatDivider,
    NgStyle,
    StyleDirective,
    TranslatePipe
  ]
})
export class CommentsComponent implements AfterViewInit {
  @ViewChild('commentList') commentList: CommentListComponent;

  public commentables: Commentable[];
  protected initialSelection: Commentable;
  protected selectedCommentable: Commentable;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {
    this.commentables = data.commentables;
    this.initialSelection = data.initialSelection;
  }

  ngAfterViewInit(): void {
    if (this.selectedCommentable) {
      this.commentList.commentable = this.selectedCommentable;
    }
  }

  commentableSelected(commentable: Commentable) {
    this.selectedCommentable = commentable;
    this.commentList &&
    (this.commentList.commentable = this.selectedCommentable);
  }
}
